<template>
  <v-container class="home">
    <div class="d-flex mt-5" :class="$root.mobile ? 'justify-center' : ''">
      <img
        src="../assets/app.jpeg"
        :width="$root.mobile ? '100px' : '200px'"
        height="50px"
        class="logo"
      />
    </div>
    <div
      class="mt-3"
      :class="$root.mobile ? 'subtitle-1  text-center' : 'title'"
    >
      Rental Application for Alpine Leasing
    </div>
    <Alert class="mt-3" />
    <Stepper />
  </v-container>
</template>

<script>
import Stepper from "../home/Stepper.vue";
import Alert from "../home/Alert";
export default {
  components: { Stepper, Alert },
  async mounted() {
    // const vm = this;
    // try {
    //   vm.$root.loader = true;
    //   await vm.$store.dispatch("get");
    //   vm.$root.loader = false;
    // } catch (e) {
    //   vm.$root.loader = false;
    // }
  }
};
</script>

<style scoped>
.home {
  max-width: 900px;
}
.home .title {
  font-weight: normal;
}
</style>
